import { render, staticRenderFns } from "./versioning.vue?vue&type=template&id=741f5e7e&"
import script from "./versioning.vue?vue&type=script&lang=js&"
export * from "./versioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports